import { closeAllOpenOverlays } from "./sidebar_overlay.js";
import { setDashboardViewMode } from "./dashboard_view.js";

let keyboardShortcutsInitialized = false;
let lastPointerX = null;
let lastPointerY = null;

function isTypingContext(target) {
  if (!(target instanceof Element)) {
    return false;
  }

  if (target.closest("input, textarea, select")) {
    return true;
  }

  const editableHost = target.closest("[contenteditable='true'], [contenteditable='plaintext-only']");
  return Boolean(editableHost);
}

function submitForm(form) {
  if (!(form instanceof HTMLFormElement)) {
    return;
  }

  if (typeof form.requestSubmit === "function") {
    form.requestSubmit();
    return;
  }

  form.submit();
}

function submitVisibilityMode(mode) {
  const modeInput = document.querySelector("form[action='/dashboard/visibility'] input[name='mode'][value='" + String(mode) + "']");
  if (!(modeInput instanceof HTMLInputElement)) {
    return false;
  }

  const form = modeInput.closest("form");
  if (!(form instanceof HTMLFormElement)) {
    return false;
  }

  submitForm(form);
  return true;
}

function submitMarkAllAsRead() {
  const readAllButton = document.querySelector("form[action='/entries/read/current'] button[name='bulk_action'][value='read_all']");
  if (!(readAllButton instanceof HTMLButtonElement)) {
    return false;
  }

  const form = readAllButton.closest("form");
  if (!(form instanceof HTMLFormElement)) {
    return false;
  }

  submitForm(form);
  return true;
}

function cardFromPointer() {
  if (!Number.isFinite(lastPointerX) || !Number.isFinite(lastPointerY)) {
    return null;
  }

  const hovered = document.elementFromPoint(lastPointerX, lastPointerY);
  if (!(hovered instanceof Element)) {
    return null;
  }

  const card = hovered.closest(".entry-grid-card[data-entry-id]");
  return card instanceof HTMLElement ? card : null;
}

function cardFromFocus() {
  const focused = document.activeElement;
  if (!(focused instanceof Element)) {
    return null;
  }

  const card = focused.closest(".entry-grid-card[data-entry-id]");
  return card instanceof HTMLElement ? card : null;
}

function starCardUnderPointerOrFocus() {
  const card = cardFromPointer() || cardFromFocus();
  if (!(card instanceof HTMLElement)) {
    return false;
  }

  const starForm = card.querySelector("form[action^='/entries/'][action$='/star']");
  if (!(starForm instanceof HTMLFormElement)) {
    return false;
  }

  submitForm(starForm);
  return true;
}

function toggleSidebarVisibility() {
  const sidebarToggleButton = document.getElementById("dashboard-sidebar-toggle");
  if (!(sidebarToggleButton instanceof HTMLButtonElement)) {
    return false;
  }

  sidebarToggleButton.click();
  return true;
}

function closeBulkMenuAndOverlays() {
  document.querySelectorAll("details.dashboard-bulk-menu[open]").forEach(function (menu) {
    menu.removeAttribute("open");
  });
  closeAllOpenOverlays();
}

function handleKeyboardShortcut(event) {
  if (!(event instanceof KeyboardEvent)) {
    return;
  }

  if (event.defaultPrevented || event.ctrlKey || event.metaKey || event.altKey) {
    return;
  }

  const key = String(event.key || "").trim().toLowerCase();
  if (!key) {
    return;
  }

  if (key === "escape") {
    closeBulkMenuAndOverlays();
    return;
  }

  if (isTypingContext(event.target)) {
    return;
  }

  if (key === "r") {
    if (submitVisibilityMode("unread")) {
      event.preventDefault();
    }
    return;
  }

  if (key === "e") {
    if (submitVisibilityMode("all")) {
      event.preventDefault();
    }
    return;
  }

  if (key === "a") {
    if (submitMarkAllAsRead()) {
      event.preventDefault();
    }
    return;
  }

  if (key === "b") {
    if (toggleSidebarVisibility()) {
      event.preventDefault();
    }
    return;
  }

  if (key === "s") {
    if (starCardUnderPointerOrFocus()) {
      event.preventDefault();
    }
    return;
  }

  if (key === "1") {
    if (setDashboardViewMode("card")) {
      event.preventDefault();
    }
    return;
  }

  if (key === "2") {
    if (setDashboardViewMode("list")) {
      event.preventDefault();
    }
    return;
  }

  if (key === "3") {
    if (setDashboardViewMode("expanded")) {
      event.preventDefault();
    }
    return;
  }

  if (key === "4") {
    if (setDashboardViewMode("full")) {
      event.preventDefault();
    }
  }
}

export function initKeyboardShortcuts() {
  if (keyboardShortcutsInitialized) {
    return;
  }
  keyboardShortcutsInitialized = true;

  document.addEventListener("mousemove", function (event) {
    lastPointerX = event.clientX;
    lastPointerY = event.clientY;
  }, { passive: true });

  document.addEventListener("keydown", handleKeyboardShortcut);
}
